module.exports = __webpack_public_path__ + "assets/img/close.6ef8d596.svg";